import { useMemo } from 'react'
import useIsMobile from './useIsMobile'
import useIsDesktop from './useIsDesktop'

export const useHeroImage = (isHeroDefault) => {
  const isMobile = useIsMobile(600) // Mobile breakpoint at 600px
  const isDesktop = useIsDesktop(1024) // Desktop breakpoint at 1024px
  const heroContent = 'logos-7'

  return useMemo(() => {
    let size = null
    if (isHeroDefault) {
      return null
    }
    if (isMobile) {
      size = 'sm'
    } else if (!isDesktop) {
      size = 'md' // Tablet (between 600px and 1024px)
    } else {
      size = 'lg' // Desktop (above 1024px)
    }

    return size
      ? `https://assets-imgx.fubo.tv/marketing/lp/images/welcome/${heroContent}-${size}.png`
      : null
  }, [isMobile, isDesktop, heroContent, isHeroDefault])
}
